import { Link } from 'react-router-dom';
import { BidText } from '../common/BidToken';

/**
 * The end of a module's pool (constitution VII): an exhausted pool must say so explicitly and
 * point at the remedy — never a blank table and never a silent repeat.
 *
 * Practice-specific by nature: "you have answered every hand in the pool" is a statement about a
 * pool, which is how a practice run measures itself.
 */
export function ExhaustedNotice({
  moduleTitle,
  backTo,
}: {
  /** The module's name, in bid-token form. */
  moduleTitle: string;
  backTo: string;
}) {
  return (
    <div className="flex-1 bg-felt-bg py-16" data-testid="module-exhausted">
      <div className="mx-auto max-w-xl rounded-xl bg-cream p-8 text-center">
        <h1 className="font-serif text-2xl text-ink">
          <BidText text={moduleTitle} />
        </h1>
        <p className="mt-3 text-ink-soft">
          No more unseen questions in this module. You have answered every hand in the pool.
        </p>
        <p className="mt-2 text-sm text-ink-soft">
          To practise these hands again, use <strong>Clear Problem History</strong> on your Account
          page — it resets every practice surface at once.
        </p>
        <div className="mt-5 flex flex-wrap justify-center gap-3">
          <Link
            to={backTo}
            className="rounded-full bg-primary-600 px-5 py-2.5 font-bold text-white no-underline hover:bg-primary-700"
          >
            Back to modules
          </Link>
          <Link
            to="/account"
            className="rounded-full border border-brass bg-cream px-5 py-2.5 font-bold text-brass-text no-underline hover:bg-paper"
          >
            Go to Account
          </Link>
        </div>
      </div>
    </div>
  );
}
